import React, { useRef } from "react";
import PropTypes from "prop-types";
import MobileActionBarContext from "./MobileActionBarContext";

function MobileActionBar({ children }) {
  const portalRef = useRef(null);

  return (
    <MobileActionBarContext.Provider value={portalRef}>
      {children}
      <div ref={portalRef} className="mobile-action-bar d-md-none" />
    </MobileActionBarContext.Provider>
  );
}

MobileActionBar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MobileActionBar;
